import { OrganizationFormData } from 'features/my-profile/become-fundraiser/form/components/add-organization/useAddOrganizationForm';
import { usePopup } from 'hooks/usePopup';

import SearchOrganization from './SearchOrganization';

export const useSearchOrganizationsPopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const showOrganizationsPicker = (onSelected: (organization: OrganizationFormData) => void) => {
    showPopup(
      <SearchOrganization
        onSelected={organization => {
          hidePopup();
          onSelected(organization);
        }}
      />,
      { keepPopups: true }
    );
  };

  return { showOrganizationsPicker };
};
